import { useState } from 'react';

interface FailureDetailsLinkProps {
  /** What the platform said, verbatim. Hidden until the link is opened. */
  detail: string;
}

/** "Details" link under a failed-post sentence; opens the raw platform text in place. */
export function FailureDetailsLink({ detail }: FailureDetailsLinkProps) {
  const [open, setOpen] = useState(false);
  return (
    <div className="space-y-0.5">
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
        className="text-detail text-muted-foreground underline underline-offset-2 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        {open ? 'Hide details' : 'Details'}
      </button>
      {open ? (
        <p className="break-words text-detail text-muted-foreground" data-testid="failure-detail">
          {detail}
        </p>
      ) : null}
    </div>
  );
}
